import { TraderTrialInfoAction } from './trader-trial.action';

export interface TraderTrialState {
  values: TraderTrial[];
  pending: boolean;
  error: any;
}

export interface TraderTrial {
  userEmail: string;
  purchasedAt: Date;
  from: string;
  expiresAt: Date;
  userId: string;
  updatedAt: Date;
  createdAt: Date;
  userCpfCnpj: string;
  id: string;
  productId: string;
  type: string;
  status: string;
}

export const initialState: TraderTrialState = {
  values: [],
  pending: false,
  error: null,
};

export function TraderTrialInfoReducer(
  state = initialState,
  action: TraderTrialInfoAction
) {
  switch (action.type) {
    case TraderTrialInfoAction.traderTrialInfo:
      return { ...state, pending: true, error: null };
    case TraderTrialInfoAction.traderTrialInfoSuccess:
      return {
        ...state,
        values: action.payload,
        pending: false,
        error: null,
      };
    case TraderTrialInfoAction.traderTrialInfoError:
      return { ...state, pending: false, error: action.payload };
    default:
      return state;
  }
}
